import { ComponentConfig, FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../../components/common/tooltip';
import {
  MarginProps,
  MarginType,
  marginFields,
} from '../../../../page-builder/puck/reusable-props/NewMargin';
import {
  paddingFields,
  PaddingProps,
  PaddingType,
} from '../../../../page-builder/puck/reusable-props/padding';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../../services/constants';
import {
  getBorderProps,
  getcurrentDeviceType,
  getNewMarginStyles,
  getPaddingStyles,
} from '../../../utils/helper';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import {
  checkAndReturnWithProductVariantIdPrefix,
  getIsViewIsEdit,
  PageType,
} from '../../../utils/constants';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import { useDispatch } from 'react-redux';
import Toggle from '../../../../components/common/toggleButton';
import InputField from '../../../../components/common/input-field';
import WithAccordion from '../../customComponents/CustomAccordion';
import {
  setCurrentUpsellData,
  setSelectedProductsForMultiProducts,
  setSelectedUpsellItems,
} from '../../../redux/slices/postUpsellSlice';
import {
  setErrorStatus,
  setIsLoading,
} from '../../../redux/slices/postUpsellStateSlice';
import { useCallback } from 'react';
import {
  ErrorResponse,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import {
  ISelectedUpsellItems,
  postUpsellPurchasePayload,
} from '../../../interface/postUpsellInterface';
import checkoutService from '../../../api/checkoutService';
import NewMarginFiled from '../../../puck/reusable-props/newMarginField';
import PaddingComponent from '../../customComponents/PaddingComponent';
import { Select } from '../../form-fields/Select';
import { Switch } from '@mui/material';
import BackgroungColorComponent from '../../customComponents/BackgroungColorComponent';
import { ITextFieldOptions } from '../../../interface/formInterface';
import { InputFormField } from './inputFormOption';
import WidthAndHeight, {
  WidthAndHeightSubProps,
} from '../../../puck/reusable-props/widthAndHeight';
import ColorPicker from '../../../puck/reusable-props/ColorPicker';
import QuilHelper from '../../../puck/reusable-props/quilHelper';
import QuillFieldRenderer from '../../carousel review/QuillFieldRenderer';
import { EachProductCard } from './eachProductCard';
import { widthOptions, WidthProps } from '../../../puck/reusable-props/width';
import { fontSizeOptions } from '../../../puck/reusable-props/font';
import { fontWeightOptions } from '../../../puck/reusable-props/TextCustomInput';

export type MultiProductProps = {
  border: IBorderValueProps;
  noOfProdPerRow: {
    deviceType: 'desktop' | 'mobile' | 'tablet';
    count: { desktop: number; mobile: number; tablet: number };
  };
  buttonCustomization: {
    removeButtonText: string;
    buttonText: string;
    Padding: PaddingType;
    Border: IBorderValueProps;
    Margin: MarginType;
    hideButton: boolean;
    buttonPosition: string;
    backgroundColor: {
      color: string;
      isInherit: boolean;
    };
    hidePrice: boolean;
    priceColor: string;
    priceFontSize: string;
    priceFontWeight: string;
  } & WidthProps;
  declineButtonCustomization: {
    buttonText: string;
    Padding: PaddingType;
    Border: IBorderValueProps;
    Margin: MarginType;
    showButton: boolean;
    buttonPosition: string;
    backgroundColor: {
      color: string;
      isInherit: boolean;
    };
  };
  noOfProdForPreview: number;
  orderDetailsCustomization: {
    subTotalText: string;
    grandTotalText: string;
    shippingText: string;
    discountText: string;
    hideSubTotal: boolean;
    hideShipping: boolean;
    hideDiscount: boolean;
    hideGrandTotal: boolean;
    color: string;
    Padding: PaddingType;
  };
  cardCustomization: {
    backgroundColor: {
      color: string;
      isInherit: boolean;
    };
    cardPosition: string;
    hideShadow: boolean;
    Border: IBorderValueProps;
  };
  imageCustomization: {
    Border: IBorderValueProps;
    hideImage: boolean;
    imageSize: WidthAndHeightSubProps;
  };

  productName: ITextFieldOptions;
  productPrice: ITextFieldOptions;
  productVariantStyle: ITextFieldOptions;
  stayOnPage: boolean;
} & MarginProps &
  PaddingProps &
  showComponentProps;

export const MultiProduct = ({
  useAppSelector,
  useAppDispatch,
}: ReduxSelectorProps &
  ReduxDispatchProps): ComponentConfig<MultiProductProps> => {
  return {
    label: (
      <CustomTooltip title="Product">
        <span>Multi Product</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,

      cardCustomization: {
        type: 'custom',
        label: 'Card Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Card Customization">
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Card Position">
                      <span>Card Position</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Select
                  className="pagebuilder-theme"
                  value={value?.cardPosition}
                  onChange={e => {
                    const selectedValue = e.target.value;
                    onChange({
                      ...value,
                      cardPosition: selectedValue,
                    });
                  }}
                  options={[
                    { value: 'col', label: 'Column' },
                    { value: 'row', label: 'Row' },
                  ]}
                />
              </FieldLabel>
              <BackgroungColorComponent
                value={value?.backgroundColor}
                onChange={val => {
                  onChange({
                    ...value,
                    backgroundColor: val,
                  });
                }}
                title="Background Color"
              />
              <Border
                value={value?.Border}
                onChange={val => {
                  onChange({
                    ...value,
                    Border: val,
                  });
                }}
                title="Border"
              />
              <div className="flex gap-2 items-center justify-between">
                <label>Hide Shadow Effect</label>
                <Switch
                  checked={value?.hideShadow}
                  onChange={e => {
                    onChange({
                      ...value,
                      hideShadow: e.target.checked,
                    });
                  }}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </div>
            </WithAccordion>
          );
        },
      },
      imageCustomization: {
        type: 'custom',
        label: 'Image Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Image Customization">
              <WidthAndHeight
                value={value?.imageSize}
                onChange={val => {
                  onChange({
                    ...value,
                    imageSize: val,
                  });
                }}
                title={'Height & Width'}
              />

              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide Image">
                      <span>Hide Image</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideImage}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideImage: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <Border
                value={value?.Border}
                onChange={val => {
                  onChange({
                    ...value,
                    Border: val,
                  });
                }}
                title="Border"
              />
            </WithAccordion>
          );
        },
      },
      buttonCustomization: {
        type: 'custom',
        label: 'Button Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Button Customize">
              <QuilHelper
                value={value?.buttonText}
                onChange={val => {
                  onChange({
                    ...value,
                    buttonText: val,
                  });
                }}
                enableLink={true}
                id={1}
              />
              <QuilHelper
                value={value?.removeButtonText}
                onChange={val => {
                  onChange({
                    ...value,
                    removeButtonText: val,
                  });
                }}
                enableLink={true}
                id={2}
              />
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Width">
                      <span>Width</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }
                el="div">
                <Select
                  className="w-full"
                  value={value?.width || ''}
                  onChange={e =>
                    onChange({
                      ...value,
                      width: e.target.value,
                    })
                  }
                  options={widthOptions}
                />
              </FieldLabel>
              <NewMarginFiled
                value={value?.Margin}
                onChange={val => {
                  onChange({
                    ...value,
                    Margin: val,
                  });
                }}
                title="Margin"
              />
              <PaddingComponent
                value={value?.Padding}
                onChange={val => {
                  onChange({
                    ...value,
                    Padding: val,
                  });
                }}
                title="Padding"
              />
              <Border
                value={value?.Border}
                onChange={val => {
                  onChange({
                    ...value,
                    Border: val,
                  });
                }}
                title="Border"
              />
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Button Position">
                      <span>Button Position</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Select
                  className="pagebuilder-theme"
                  value={value?.buttonPosition}
                  onChange={e => {
                    const selectedValue = e.target.value;
                    onChange({
                      ...value,
                      buttonPosition: selectedValue,
                    });
                  }}
                  options={[
                    { value: 'bottom', label: 'Bottom' },
                    { value: 'right', label: 'Right' },
                  ]}
                />
              </FieldLabel>

              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide Button">
                      <span>Hide Button</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideButton}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideButton: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <BackgroungColorComponent
                value={value?.backgroundColor}
                onChange={val => {
                  onChange({
                    ...value,
                    backgroundColor: val,
                  });
                }}
                title="Background Color"
              />
              <WithAccordion title="Price in button">
                <div className="flex gap-2 items-center justify-between">
                  <label>Hide Price</label>
                  <Switch
                    checked={value?.hidePrice}
                    onChange={e => {
                      onChange({
                        ...value,
                        hidePrice: e.target.checked,
                      });
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
                <ColorPicker
                  value={value.priceColor}
                  onChange={color =>
                    onChange({
                      ...value,
                      priceColor: color,
                    })
                  }
                  label={'Text Color'}
                  tooltip={'textColor'}
                />
                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="fontSize">
                        <span>Font Size</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    className="pagebuilder-theme"
                    value={value?.priceFontSize}
                    onChange={e =>
                      onChange({
                        ...value,
                        priceFontSize: e.target.value,
                      })
                    }
                    options={fontSizeOptions}
                    label="Size"
                  />
                </FieldLabel>

                <FieldLabel
                  label={
                    (
                      <CustomTooltip title="fontWeight">
                        <span>Font Weight</span>
                      </CustomTooltip>
                    ) as React.ReactNode as string
                  }>
                  <Select
                    value={value?.priceFontWeight}
                    onChange={e =>
                      onChange({
                        ...value,
                        priceFontWeight: e.target.value,
                      })
                    }
                    options={fontWeightOptions}
                  />
                </FieldLabel>
              </WithAccordion>
            </WithAccordion>
          );
        },
      },
      declineButtonCustomization: {
        type: 'custom',
        label: 'Decline Button Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Decline Button Customize">
              <QuilHelper
                value={value?.buttonText}
                onChange={val => {
                  onChange({
                    ...value,
                    buttonText: val,
                  });
                }}
                enableLink={true}
                id={3}
              />
              <NewMarginFiled
                value={value?.Margin}
                onChange={val => {
                  onChange({
                    ...value,
                    Margin: val,
                  });
                }}
                title="Margin"
              />
              <PaddingComponent
                value={value?.Padding}
                onChange={val => {
                  onChange({
                    ...value,
                    Padding: val,
                  });
                }}
                title="Padding"
              />
              <Border
                value={value?.Border}
                onChange={val => {
                  onChange({
                    ...value,
                    Border: val,
                  });
                }}
                title="Border"
              />
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Button Position">
                      <span>Button Position</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Select
                  className="pagebuilder-theme"
                  value={value?.buttonPosition}
                  onChange={e => {
                    const selectedValue = e.target.value;
                    onChange({
                      ...value,
                      buttonPosition: selectedValue,
                    });
                  }}
                  options={[
                    { value: 'bottom', label: 'Bottom' },
                    { value: 'right', label: 'Right' },
                  ]}
                />
              </FieldLabel>

              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide Button">
                      <span>Show Button</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.showButton}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      showButton: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <BackgroungColorComponent
                value={value?.backgroundColor}
                onChange={val => {
                  onChange({
                    ...value,
                    backgroundColor: val,
                  });
                }}
                title="Background Color"
              />
            </WithAccordion>
          );
        },
      },
      orderDetailsCustomization: {
        type: 'custom',
        label: 'Order Details Customization',
        render: ({ value, onChange }) => {
          return (
            <WithAccordion title="Order Details Customization">
              <QuillFieldRenderer
                label="SubTotal"
                value={value?.subTotalText}
                onChange={val =>
                  onChange({
                    ...value,
                    subTotalText: val,
                  })
                }
                id={2}
              />

              <QuillFieldRenderer
                label="Discount"
                value={value?.discountText}
                onChange={val =>
                  onChange({
                    ...value,
                    discountText: val,
                  })
                }
                id={25}
              />

              <QuillFieldRenderer
                label="Shipping"
                value={value?.shippingText}
                onChange={val =>
                  onChange({
                    ...value,
                    shippingText: val,
                  })
                }
                id={5}
              />

              <QuillFieldRenderer
                label="GrandTotal"
                value={value?.grandTotalText}
                onChange={val =>
                  onChange({
                    ...value,
                    grandTotalText: val,
                  })
                }
                id={15}
              />
              {/* </FieldLabel> */}
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide SubTotal">
                      <span>Hide SubTotal</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideSubTotal}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideSubTotal: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide SubTotal">
                      <span>Hide Discount</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideDiscount}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideDiscount: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide SubTotal">
                      <span>Hide Shipping</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideShipping}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideShipping: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <FieldLabel
                label={
                  (
                    <CustomTooltip title="Hide GrandTotal">
                      <span>Hide GrandTotal</span>
                    </CustomTooltip>
                  ) as React.ReactNode as string
                }>
                <Switch
                  className="flex justify-between items-center mb-3"
                  checked={value?.hideGrandTotal}
                  onChange={e => {
                    const selectedValue = e.target.checked;
                    onChange({
                      ...value,
                      hideGrandTotal: selectedValue,
                    });
                  }}
                />
              </FieldLabel>
              <ColorPicker
                label="Amount Color"
                value={value?.color}
                onChange={color =>
                  onChange({
                    ...value,
                    color: color,
                  })
                }
                tooltip="Color"
              />

              <PaddingComponent
                value={value?.Padding}
                onChange={val => {
                  onChange({
                    ...value,
                    Padding: val,
                  });
                }}
                title="Padding"
              />
            </WithAccordion>
          );
        },
      },

      productName: {
        type: 'custom',
        label: 'Product Name Customization',
        render: ({ value, onChange }) => {
          return (
            <InputFormField
              key="placeholder"
              name="Product Name Customization"
              value={value}
              onChange={onChange}
            />
          );
        },
      },

      productPrice: {
        type: 'custom',
        label: 'Product Price Customization',
        render: ({ value, onChange }) => {
          return (
            <InputFormField
              key="placeholder"
              name="Product Price Customization"
              value={value}
              onChange={onChange}
            />
          );
        },
      },
      productVariantStyle: {
        type: 'custom',
        label: 'Product Variant Customization',
        render: ({ value, onChange }) => {
          return (
            <InputFormField
              key="placeholder"
              name="Product Variant"
              value={value}
              onChange={onChange}
            />
          );
        },
      },
      noOfProdPerRow: {
        type: 'custom',
        label: 'Number of Products Per Row',
        render: ({ value, onChange }) => (
          <WithAccordion title="No of Product Per Row">
            <Toggle
              value={value}
              onChange={newValue => onChange({ ...value, ...newValue })}
              heading={{ label: 'Device', value: 'device' }}
              options={[
                { label: 'Desktop', value: 'desktop' },
                { label: 'Tablet', value: 'tablet' },
                { label: 'Mobile', value: 'mobile' },
              ]}
              propName="deviceType"
            />
            <div className="">
              <InputField
                value={value?.count?.[value?.deviceType]}
                onChange={e => {
                  const regex = /^[1-9]?$/;
                  if (regex.test(e)) {
                    onChange({
                      ...value,
                      count: {
                        ...value?.count,
                        [value.deviceType]: e,
                      },
                    });
                  }
                }}
                className="h-[42px]"
                label="Count"
              />
            </div>
          </WithAccordion>
        ),
      },
      noOfProdForPreview: {
        type: 'custom',
        label: 'No of Product For Preview',
        render: ({ value, onChange }) => (
          <WithAccordion title="No of Product For Preview">
            <div className="">
              <label htmlFor="email" className="block text-sm font-medium pb-3">
                {'Count'}
              </label>
              <input
                type="number"
                className="w-full h-[42px] px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                min={1}
                max={100}
                value={value}
                onChange={e => {
                  const regex = /^(100|[1-9][0-9]?|)$/;
                  if (regex.test(e.target.value)) {
                    onChange(
                      e.target.value === '' ? 1 : Number(e.target.value),
                    );
                  }
                }}
                placeholder="Enter number of products for preview"
              />
            </div>
          </WithAccordion>
        ),
      },
      stayOnPage: {
        type: 'custom',
        label: 'Stay on Page',
        render: ({ value, onChange }) => (
          <FieldLabel
            label={
              (
                <CustomTooltip title="Stay on Page After Adding to Cart">
                  <span>Stay on Page After Adding to Cart</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <Switch
              className="flex justify-between items-center mb-3"
              checked={value}
              onChange={e => onChange(e.target.checked)}
            />
          </FieldLabel>
        ),
      },
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
    },
    defaultProps: {
      orderDetailsCustomization: {
        discountText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Discount Amount</span></p>',
        shippingText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Shipping</span></p>',
        subTotalText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">SubTotal</span></p>',
        grandTotalText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Grand Total</span></p>',
        hideSubTotal: false,
        hideGrandTotal: false,
        hideShipping: false,
        hideDiscount: false,
        color: '#000000',
        Padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      cardCustomization: {
        cardPosition: 'col',
        backgroundColor: {
          color: '#ffffff',
          isInherit: false,
        },
        Border: borderProps.border,
        hideShadow: false,
      },

      imageCustomization: {
        hideImage: false,
        imageSize: {
          deviceType: 'desktop',
          height: {
            desktop: '100%',
            mobile: '100%',
            tablet: '100%',
          },
          maxWidth: {
            desktop: '100%',
            mobile: '100%',
            tablet: '100%',
          },
        },
        Border: borderProps.border,
      },
      productName: {
        color: '#000000',
        fontSize: '14',
        fontWeight: '300',
        fontFamily: 'sans-serif',
        textBackgroundColor: {
          color: '#ffffff',
          isInherit: false,
        },
        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      productVariantStyle: {
        color: '#000000',
        fontSize: '14',
        fontWeight: '300',
        fontFamily: 'sans-serif',
        textBackgroundColor: {
          color: '#ffffff',
          isInherit: false,
        },
        hideFileds: false,
        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      productPrice: {
        color: '#000000',
        fontSize: '14',
        fontWeight: '300',
        fontFamily: 'sans-serif',
        textBackgroundColor: {
          color: '#ffffff',
          isInherit: false,
        },
        padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
      },
      buttonCustomization: {
        width: 'w-full',
        buttonText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Add to Cart +</span></p>',
        removeButtonText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Remove</span></p>',
        hideButton: false,
        buttonPosition: 'bottom',
        backgroundColor: {
          color: '#000000',
          isInherit: false,
        },
        Padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
        Border: borderProps.border,
        Margin: {
          deviceType: 'desktop',
          marginBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
        hidePrice: false,
        priceColor: '#ffffff',
        priceFontSize: '14',
        priceFontWeight: '400',
      },
      declineButtonCustomization: {
        buttonText:
          '<p style="line-height:1.5;"><span style="font-size: 16px;">Decline offer</span></p>',
        showButton: false,
        buttonPosition: 'bottom',
        backgroundColor: {
          color: '#000000',
          isInherit: false,
        },
        Padding: {
          deviceType: 'desktop',
          paddingBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          paddingTop: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
        },
        Border: borderProps.border,
        Margin: {
          deviceType: 'desktop',
          marginBottom: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginLeft: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginRight: {
            desktop: '0',
            mobile: '0',
            tablet: '0',
          },
          marginTop: {
            desktop: '8',
            mobile: '6',
            tablet: '6',
          },
        },
      },
      stayOnPage: false,
      showComponent: ['desktop', 'tablet', 'mobile'],
      ...borderProps,
      margin: {
        deviceType: 'desktop',
        marginBottom: { desktop: '0', mobile: '0', tablet: '0' },
        marginLeft: { desktop: '0', mobile: '0', tablet: '0' },
        marginRight: { desktop: '0', mobile: '0', tablet: '0' },
        marginTop: { desktop: '0', mobile: '0', tablet: '0' },
      },
      noOfProdPerRow: {
        deviceType: 'desktop',
        count: { desktop: 2, mobile: 1, tablet: 2 },
      },
      noOfProdForPreview: 2,
      padding: {
        deviceType: 'desktop',
        paddingBottom: { desktop: '0', mobile: '0', tablet: '0' },
        paddingLeft: { desktop: '0', mobile: '0', tablet: '0' },
        paddingRight: { desktop: '0', mobile: '0', tablet: '0' },
        paddingTop: { desktop: '0', mobile: '0', tablet: '0' },
      },
    },
    render: ({
      margin,
      padding,
      productName,
      productPrice,
      productVariantStyle,
      buttonCustomization,
      declineButtonCustomization,
      cardCustomization,
      editMode,
      orderDetailsCustomization,
      imageCustomization,
      border,
      showComponent,
      noOfProdPerRow,
      noOfProdForPreview,
      stayOnPage,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getNewMarginStyles(margin, currentDeviceType);
      const currentUpsellData = useAppSelector(
        state => state.postUpSell.currentUpsellData,
      );
      const isLoading = useAppSelector(
        state => state.postUpSellState.isLoading,
      );
      const selectedUpsellItems = useAppSelector(
        state => state.postUpSell.selectedUpsellItems,
      );
      const upsellData = useAppSelector(state => state.postUpSell.upsellData);
      const storeData = useAppSelector(state => state.store.storeData);
      const selectedProductsForMultiProducts = useAppSelector(
        state => state.postUpSell.selectedProductsForMultiProducts,
      );

      const IsViewIsEdit = getIsViewIsEdit();
      const sampleProduct = [
        {
          variants: [
            {
              productPrice: '51.00',
              shippingType: {
                label: 'Free',
                value: 'free',
              },
              shippingPrice: '0.00',
              discountAmount: {
                type: 'amount',
                value: '0.00',
              },
              productVariants: {
                label: 'Black / XS-S',
                value: 'gid://shopify/ProductVariant/48081859510591',
                productImage:
                  'https://phx-store-images-staging.s3.amazonaws.com/images/store/226/7b1285a5-1983-4554-a311-8c0f28e6183f-file',
                productPrice: '51.00',
              },
              displayPrice: '',
              totalUpSellPrice: '51.00',
            },
            {
              productPrice: '51.00',
              shippingType: {
                label: 'Free',
                value: 'free',
              },
              shippingPrice: '0.00',
              discountAmount: {
                type: 'amount',
                value: '0.00',
              },
              productVariants: {
                label: 'White / M-L',
                value: 'gid://shopify/ProductVariant/48081859510592',
                productImage:
                  'https://phx-store-images-staging.s3.amazonaws.com/images/store/226/7b1285a5-1983-4554-a311-8c0f28e6183f-file',
                productPrice: '55.00',
              },
              displayPrice: '',
              totalUpSellPrice: '51.00',
            },
          ],
          id: 'gid://shopify/Product/9228547064127',
          assignedProducts: {
            label: 'Example Product 1',
            value: 9228547064127,
          },
        },
      ];

      const dispatch = useDispatch();
      const navigate = useNavigate();
      const { pathname } = useLocation();
      const [searchParams] = useSearchParams();
      const newSearchParams = new URLSearchParams(searchParams.toString());
      const checkoutState = useAppSelector(state => state.checkout);
      const { checkoutOrderID, purchaseToken } = checkoutState;
      const smartUpsellFunnelID = useAppSelector(
        state => state.postUpSell.smartUpsellFunnelID,
      );
      const isCheckoutPaymentPaypal = useAppSelector(
        state => state.common.isPaymentByPaypal,
      );
      const IndependentTransactionForUpsellPages =
        storeData?.IndependentTransactionForUpsellPages ||
        isCheckoutPaymentPaypal ||
        false;
      const isUpsellFunnelPreview = searchParams.get('isUpsellFunnelPreview');
      const nopfp = noOfProdForPreview || 2;
      const products =
        IsViewIsEdit && !isUpsellFunnelPreview
          ? Array.from({ length: nopfp }).flatMap(() =>
              sampleProduct.map(product => ({ ...product })),
            )
          : currentUpsellData?.products || [];
      let navStateForUpsell = {};
      if (
        !getIsViewIsEdit() &&
        upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId
      ) {
        navStateForUpsell = {
          state: upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId
            ? {
                id: upsellData?.[currentUpsellData?.accept?.nextProduct]
                  ?.pageId,
                pageVisiblity: '',
                pageType: PageType.UPSELL,
              }
            : {},
        };
      }
      let navStateForConfirmation = {};
      if (!getIsViewIsEdit() && checkoutState?.nextpageConfig?.id) {
        navStateForConfirmation = {
          state: checkoutState?.nextpageConfig?.id
            ? {
                id: checkoutState?.nextpageConfig?.id,
                pageVisiblity: checkoutState?.nextpageConfig?.pageVisiblity,
                pageType: checkoutState?.nextpageConfig?.pageType,
              }
            : {},
        };
      }
      let declineNavState = {};
      if (
        !getIsViewIsEdit() &&
        upsellData?.[currentUpsellData?.decline?.nextProduct]?.pageId
      ) {
        declineNavState = {
          state: upsellData?.[currentUpsellData?.decline?.nextProduct]?.pageId
            ? {
                id: upsellData?.[currentUpsellData?.decline?.nextProduct]
                  ?.pageId,
                pageVisiblity: '',
                pageType: 'upsell',
              }
            : {},
        };
      }
      const navigateDownsellFunction = useCallback(() => {
        if (upsellData?.[currentUpsellData?.decline?.nextProduct]?.pageId) {
          navigate(
            pathname + '?' + newSearchParams.toString(),
            declineNavState,
          );
        }
      }, [upsellData?.[currentUpsellData?.decline?.nextProduct]?.pageId]);
      const navigateFunctionForUpsellPage = useCallback(() => {
        if (upsellData?.['' + currentUpsellData?.accept?.nextProduct].pageId) {
          navigate(
            pathname + '?' + newSearchParams.toString(),
            navStateForUpsell,
          );
        }
      }, [upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId]);

      const navigateFunctionForConfirmationPage = useCallback(() => {
        if (checkoutState?.nextpageConfig?.id) {
          navigate(
            pathname + '?' + newSearchParams.toString(),
            navStateForConfirmation,
          );
        }
      }, [
        checkoutState.nextpageConfig?.id,
        checkoutState.nextpageConfig?.pageVisiblity,
      ]);
      const openEditor = async () => {
        const newPageID =
          upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId;
        const updatedSearchParams = new URLSearchParams(
          searchParams.toString(),
        );
        updatedSearchParams.set('pageID', String(newPageID));
        navigate(pathname + '?' + updatedSearchParams.toString());
      };

      const openEditorForDecline = async () => {
        const newPageID = upsellData?.[currentUpsellData?.decline?.nextProduct]
          ?.pageId
          ? upsellData?.[currentUpsellData?.decline?.nextProduct]?.pageId
          : upsellData?.[currentUpsellData?.accept?.nextProduct]?.pageId;
        const updatedSearchParams = new URLSearchParams(
          searchParams.toString(),
        );
        updatedSearchParams.set('pageID', String(newPageID));
        navigate(pathname + '?' + updatedSearchParams.toString());
      };

      const handleCompletePurchase = useCallback(
        async (
          selectedItems: ISelectedUpsellItems[],
          isNavToThankyouPage: boolean,
        ) => {
          if (selectedItems.length === 0) {
            navigateFunctionForConfirmationPage();
            return;
          }
          const payload: postUpsellPurchasePayload = {
            LineItems: selectedItems
              .filter(item => item)
              .map(item => ({
                Quantity: 1,
                VariantID: item.variantId,
                UpsellDetails: {
                  GroupId: item.GroupId,
                  IsDownsell: item.IsDownsell,
                  DownsellId: item.IsDownsell ? (item.DownsellId ?? '') : '',
                  ProductId: item.ProductId,
                },
              })),
            OrderID: checkoutOrderID,
            PurchaseToken: purchaseToken,
            ShopID: storeData?.ShopID,
            FunnelId: Number(smartUpsellFunnelID),
            StoreID: storeData?.StoreID || '',
          };
          try {
            const res = await checkoutService.postUpsellPurchase(payload);
            if (res.status === 200) {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionForConfirmationPage();
            }
          } catch (error: unknown) {
            const err = error as ErrorResponse;
            if (err.status === 400) {
              dispatch(setIsLoading(false));
              dispatch(setErrorStatus(err.status));
              if (isNavToThankyouPage) navigateFunctionForConfirmationPage();
              throw error;
            } else {
              dispatch(setIsLoading(false));
              if (isNavToThankyouPage) navigateFunctionForConfirmationPage();
              throw error;
            }
          }
        },
        [
          navigate,
          navigateFunctionForConfirmationPage,
          checkoutOrderID,
          purchaseToken,
          storeData,
        ],
      );

      async function handleClick(
        VariantID: string,
        isSelected: boolean,
        ProductId: string,
      ) {
        if (IsViewIsEdit && !!isUpsellFunnelPreview) {
          if (!stayOnPage) {
            await openEditor();
            dispatch(
              setCurrentUpsellData(
                upsellData?.[currentUpsellData?.accept?.nextProduct],
              ),
            );
          }
        } else {
          dispatch(setIsLoading(true));
          const variantWithPrefix = checkAndReturnWithProductVariantIdPrefix(
            '' + VariantID,
          );
          const newSelectedItems = [...selectedUpsellItems];

          if (stayOnPage) {
            let newMultiProductsSelectedItems = [
              ...selectedProductsForMultiProducts,
            ];
            if (isSelected) {
              // Remove item if already selected
              newMultiProductsSelectedItems =
                newMultiProductsSelectedItems.filter(
                  item => item.variantId !== variantWithPrefix,
                );
            } else {
              // Add item if not selected
              newMultiProductsSelectedItems.push({
                variantId: variantWithPrefix,
                GroupId: currentUpsellData?.upsellgroup_id || '',
                IsDownsell: currentUpsellData?.isDownSell,
                DownsellId: currentUpsellData?.isDownSell
                  ? currentUpsellData?.downsell_id
                  : '',
                ProductId: ProductId || '',
              });
            }
            dispatch(
              setSelectedProductsForMultiProducts(
                newMultiProductsSelectedItems,
              ),
            );
            dispatch(setIsLoading(false));
          } else {
            // Original behavior when stayOnPage is false
            const currentProducts = [
              {
                variantId: variantWithPrefix,
                GroupId: currentUpsellData?.upsellgroup_id || '',
                IsDownsell: currentUpsellData?.isDownSell,
                DownsellId: currentUpsellData?.isDownSell
                  ? currentUpsellData?.downsell_id
                  : '',
                ProductId: ProductId || '',
              },
            ];
            newSelectedItems.push(...currentProducts);
            dispatch(setSelectedUpsellItems(newSelectedItems));
            await new Promise(resolve => setTimeout(resolve, 1000));
            dispatch(setSelectedUpsellItems(newSelectedItems));
            await new Promise(resolve => setTimeout(resolve, 1000));

            if (!currentUpsellData?.accept?.nextProduct) {
              try {
                IndependentTransactionForUpsellPages
                  ? await handleCompletePurchase(currentProducts, true)
                  : await handleCompletePurchase(newSelectedItems, true);
                dispatch(setIsLoading(false));
              } catch (error) {
                dispatch(setIsLoading(false));
              }
            } else {
              if (IndependentTransactionForUpsellPages)
                handleCompletePurchase(currentProducts, false);

              navigateFunctionForUpsellPage();
              dispatch(
                setCurrentUpsellData(
                  upsellData?.[currentUpsellData?.accept?.nextProduct],
                ),
              );
              dispatch(setIsLoading(false));
            }
          }
        }
      }
      const isNavToThankyouPage = !currentUpsellData?.accept?.nextProduct;
      async function handleDeclineClick() {
        dispatch(setIsLoading(true));
        if (!currentUpsellData?.decline?.nextProduct) {
          try {
            IsViewIsEdit && !!isUpsellFunnelPreview
              ? await openEditorForDecline()
              : await handleCompletePurchase(selectedUpsellItems, false);
            dispatch(setIsLoading(false));
          } catch (error) {
            dispatch(setIsLoading(false));
          }
        } else {
          IsViewIsEdit && !!isUpsellFunnelPreview
            ? await openEditorForDecline()
            : navigateDownsellFunction();
          dispatch(
            setCurrentUpsellData(
              upsellData?.[currentUpsellData?.decline?.nextProduct],
            ),
          );
          dispatch(setIsLoading(false));
        }
      }
      async function handleClickPayPal() {
        if (currentUpsellData?.accept?.nextProduct) {
          navigateFunctionForUpsellPage();
          dispatch(
            setCurrentUpsellData(
              upsellData?.[currentUpsellData?.accept?.nextProduct],
            ),
          );
        }
      }

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div>
              {/* {postUpsellState.showPopup && (
                <div
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1000,
                  }}>
                  <UpSellPopUp
                    message={postUpsellState.popupMessage}
                    onDismiss={() => {
                      dispatch(setShowPopup(false));
                      navigateFunctionForConfirmationPage();
                    }}
                  />
                </div>
              )} */}
              <div
                style={{
                  ...marginStyles,
                  ...getPaddingStyles(padding, currentDeviceType),
                  ...getBorderProps(border, currentDeviceType),
                  gridTemplateColumns:
                    products.length > 1
                      ? `repeat(${noOfProdPerRow?.count?.[currentDeviceType] || 1}, minmax(0, 1fr))`
                      : 'repeat(1, minmax(0, 1fr))',
                }}
                className={`grid gap-4 w-full ${border?.borderStyle?.[currentDeviceType]}`}>
                {products.map((product, index) => (
                  <EachProductCard
                    key={index}
                    product={product}
                    currentDeviceType={currentDeviceType}
                    cardCustomization={cardCustomization}
                    imageCustomization={imageCustomization}
                    productName={productName}
                    productPrice={productPrice}
                    productVariantStyle={productVariantStyle}
                    buttonCustomization={buttonCustomization}
                    declineButtonCustomization={declineButtonCustomization}
                    isLoading={isLoading}
                    handleClick={handleClick}
                    handleDeclineClick={handleDeclineClick}
                    orderDetailsCustomization={orderDetailsCustomization}
                    stayOnPage={stayOnPage}
                    selectedUpsellItems={selectedProductsForMultiProducts}
                    isFunnelPreview={IsViewIsEdit && !!isUpsellFunnelPreview}
                    isCheckoutPaymentPaypal={isCheckoutPaymentPaypal}
                    handleClickPayPal={handleClickPayPal}
                    purchaseToken={purchaseToken}
                    checkoutOrderID={checkoutOrderID}
                    IndependentTransactionForUpsellPages={
                      IndependentTransactionForUpsellPages
                    }
                    navigateFunctionForConfirmationPage={
                      navigateFunctionForConfirmationPage
                    }
                    storeData={storeData}
                    currentUpsellData={currentUpsellData}
                    isNavToThankyouPage={isNavToThankyouPage}
                    smartUpsellFunnelID={smartUpsellFunnelID}
                    useAppDispatch={useAppDispatch}
                    useAppSelector={useAppSelector}
                  />
                ))}
              </div>
            </div>
          )}
        </>
      );
    },
  };
};
